<ng-container *ngIf="!editLang">
    <div class="row justify-content-end pr-3">
        <button class="btn btn-success mb-3" data-target="#demo" data-toggle="collapse" (click)="add()">Add new</button>
    </div>
    <div class="light-bg w-100 float-left p-2 grid-details" (click)="clicked()">
        <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
            <h6 class="mb-lg-0 medium"> {{'name' | translate}} </h6>
        </div>
        <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
            <h6 class="mb-lg-0 medium"> {{'locale' | translate}} </h6>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
            <h6 class="mb-lg-0 medium"> {{'action' | translate}} </h6>
        </div>
    </div>
    <ng-container *ngIf="notificationLangPageData.content && notificationLangPageData.content.length > 0">
        <div class="w-100 float-left p-2 grid-details collapse"
             *ngFor="let lang of notificationLangPageData.content ; let i=index">
            <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 text-truncate"> {{lang.name}} </h6>
            </div>
            <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 text-truncate"> {{lang.locale}} </h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative">
                <h6 class="mb-lg-0" (click)="tableActions(i)" ngbTooltip="Click for more options">
                    <i class="fa fa-ellipsis-h"></i>
                </h6>
                <div class="empActions m-t-nsmd" *ngIf="i == trackHides">
                    <i class="fa fa-caret-up caret-up"></i>
                    <ul class="m-0 p-0">
                        <li (click)="edit(lang)">
                            <i class="fa fa-pencil mr-2"></i> {{'edit' | translate}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="notificationLangPageData.content 
        && notificationLangPageData.content.length == 0">
        <div class="w-100 float-left min-h2 relative" *ngIf="showLoading">
            <!-- <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">
                <img src="./assets/img/load.gif" alt="loading" width="80px">
            </div> -->
            <div class="loader-div">
                <!-- <img src="assets/images/loader.gif" [ngStyle]="{'width':'100px'}" alt="loading"> -->
                <div class="loader-gif"></div>
            </div>
        </div>
        <div class="w-100 float-left p-4 grid-details" *ngIf="!showLoading">
            <p class="text-center m-0 w-100 medium">{{'noResultFound' | translate}}</p>
        </div>
    </ng-container>

    <!-- PAGINATION -->
    <div class="w-100 float-left my-4 light-bg p-3 align-v-center" (click)="clicked()">
        <h6 class="float-left mb-0"> {{((search.page-1)*search.pageSize)+1}} -
            {{search.pageSize*(search.page-1)+notificationLangPageData.numberOfElements}}
            {{'itemsOf' | translate}} {{notificationLangPageData.totalElements}} </h6>
        <div class="float-left ml-2 align-v-center">
            <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
            <select class="form-control float-left w-auto ml-2 mb-0" name="pageSize" [(ngModel)]="search.pageSize"
                    (change)="fetchNotificationLang()">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
            </select>
        </div>
        <div style="flex-grow: 1;"></div>
        <ngb-pagination [collectionSize]="notificationLangPageData.totalElements" [rotate]="true" [maxSize]="5"
                        [pageSize]="search.pageSize"
                        [ellipses]="false" [(page)]="search.page" [boundaryLinks]="true"
                        (pageChange)="fetchNotificationLang()"
                        class="float-right"></ngb-pagination>

        <div (click)="onRefresh()" data-toggle="tooltip" data-placement="bottom" title="Refresh"
             style="margin-right:1px; margin-left:10px;cursor: pointer;"><i
                class="fa fa-refresh" aria-hidden="true"></i></div>
    </div>

</ng-container>
<ng-container *ngIf="editLang">
    <editNotificationLang [notificationLang]="editingLang" (triggerSave)="save()" (cancel)="cancel()">
    </editNotificationLang>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/notificationLangGridComponent.html